import React from 'react';
import PrintableProjectDocument from './PrintableProjectDocument';

const DevisPDFComponent = () => <PrintableProjectDocument type="estimate" />;

export default DevisPDFComponent;
